/* globals gformCalculateTotalPrice */

/**
 * Functionality hidden embedded Gravity Forms
 *
 * Script is loaded if/when hidden_form shortcode is used
 *
 * Requires WP jQuery and GEN$ jQuery
 */
(function( $ ) {
	'use strict';

	$(function() {

		let $form;
		let hiddenFormId = $('body').data('showHiddenFormId');

		/**
		 * Scroll to the donation form
		 */
		const scrollToForm = function() {

			let $scrollTo;

			if( hiddenFormId ) {
				$scrollTo = $(`#gen-form-id-${hiddenFormId}` );
			} else {
				$scrollTo = $('.gen-form');
			}

			GENThemeTools.scrollTo( $scrollTo, 750 );

		};

		//show the hidden form next to the button
		$('.js-hidden-form-button-show').click( function() {
			hiddenFormId = $(this).data('formId');
			let insertAt = $(this).data('insertAt');
			let fieldVals = $(this).data('fieldVals');
			let insertingAt = false;

			let fieldVal, $insertAt, $setField, sel;

			if( insertAt ) {
				$insertAt = $('#' + insertAt);
				insertingAt = !!$insertAt.length;
			}

			//field_vals data param added by shortcode
			//to set field values when we click button
			if( fieldVals ) {
				fieldVals = fieldVals.split('&');
				for (let i = 0; i < fieldVals.length; i++) {
					fieldVal = fieldVals[i].split('=');

					$setField = $( '#' + fieldVal[0] );

					//if radio button
					//check relevant radio button and hide others
					if( $setField.hasClass('gfield_radio') ) {
						sel = `#${fieldVal[0]} input[value='${fieldVal[1]}']`;
						$setField.find('input').prop('disabled', true);
						$(sel).prop('checked', true);
						$(sel).prop('disabled', false);
						$setField.find('input:not(:checked)').parent().hide();
						$setField.find('input:checked').parent().show();
						$setField.find('input:checked').hide();
					} else {
						$setField.val( fieldVal[1] ).prop('disabled',true);
					}

					//just in case
					gformCalculateTotalPrice(hiddenFormId);
				}
			}

			$form = $( '#gen-form-id-' + hiddenFormId );

			if( insertingAt ) {
				$insertAt.append( $form.detach() );
				GENThemeTools.scrollTo( $insertAt );
			} else {
				$form.detach().insertBefore(this);
			}

			$form.slideDown();
			scrollToForm();

			//hide the button, but only if the form isn't elsewhere on screen
			if( ! insertingAt ) {
				$(this).hide();
			}
		});

		//if we are loading after submit, make sure form shows and hide buttons
		if( hiddenFormId ) {
			const $hiddenForm = $( '#gen-form-id-' + hiddenFormId );
			const $buttonWrap = $hiddenForm.siblings( '.hidden-form-button-wrap' );
			const insertAt = $buttonWrap.find('button').data('insertAt');

			let $insertAt, insertingAt;

			if( insertAt ) {
				$insertAt = $('#' + insertAt);
				insertingAt = !!$insertAt.length;
			}

			if( insertingAt ) {
				$insertAt.append( $hiddenForm.detach() );
			}

			$hiddenForm.siblings( '.hidden-form-button-wrap' ).hide();
			$hiddenForm.show();

			scrollToForm();
		}

	});

}( GEN$ ));